import * as React from "react";
import _ from "lodash";
import moment from "moment";
import { Input, Tabs } from "antd";
const Search = Input.Search;

const TabPane = Tabs.TabPane;

import { FlyerThumbnail } from "../";
import { QuerySelectorLoadSpin } from "../../../../AnalyticsMetric/components/Spin";
import Button from "../../../../core/Button";
import { Merchant } from "../../../../Merchant";
import { Publication } from "../../../../Analytics";

import "./style.scss";

import { Checkbox, DatePicker, AutoComplete } from "antd";
const RangePicker = DatePicker.RangePicker;

export interface QueryMenuProps {
  startDate: string;
  endDate: string;
  merchantId: number;
  merchants: Merchant[];
  publicationIds: number[];
  publications: Publication[];
  publications_loading?: boolean;
  selectedMerchant: Merchant;
  dateSelectionLimit?: number;
}
export interface QuerySelectorActions {
  handleMerchantSelect: (value: number) => void;
  handleRangeSelect: (date_range: any[]) => void;
  toggleMenu: (revertState?: boolean) => void;
  togglePublication: (
    publication: Publication[],
    selected_publication_id: [number]
  ) => void;
  selectAllPublications: (select: boolean, publicationFilter: string) => void;
  //external actions
  getPublications: (
    merchantId: number,
    startDate: string,
    endDate: string
  ) => void;
  removePublications: () => void;
  //Call back function for performing extra processing on selected publicationIds startDate endDate merchantId
  handleSubmit?: (
    publicationIds: number[],
    startDate: string,
    endDate: string,
    merchantId: number
  ) => void;
}

export interface QueryMenuState {
  searchResults: any[];
  qry: string;
  publicationFilter: string;
  useDefaultMerchant: boolean;
}

export class QueryMenu extends React.Component<
  QueryMenuProps & QuerySelectorActions,
  QueryMenuState
> {
  constructor() {
    super();
    this.state = {
      searchResults: [],
      qry: "",
      publicationFilter: "",
      useDefaultMerchant: false
    };
    this.handleChange = _.debounce(this.handleChange.bind(this), 400);
  }

  componentDidMount() {
    let antCalendarRangePicker = document.querySelector(
      ".ant-calendar-range-picker-separator"
    );

    if (antCalendarRangePicker) {
      antCalendarRangePicker.innerHTML = "-";
    }
  }

  componentWillReceiveProps(nextProps: any, nextState: any) {
    let { startDate, endDate, merchantId } = this.props;
    let dateChanged =
      nextProps.startDate != startDate || nextProps.endDate != endDate;
    let merchantChanged = nextProps.merchantId != merchantId;
    if (merchantChanged || dateChanged) {
      if (nextProps.startDate && nextProps.endDate && nextProps.merchantId)
        this.props.getPublications(
          nextProps.merchantId,
          nextProps.startDate,
          nextProps.endDate
        );
      else this.props.removePublications();
    }
  }

  handleChange = (qry: any) => {
    if (this.props.merchantId != qry) {
      if (this.state.useDefaultMerchant)
        this.setState({ useDefaultMerchant: false });

      let results = this.props.merchants.filter(
        (i: any) => i.name && String(i.name).toLowerCase().indexOf(qry.toLowerCase()) != -1
      );
      this.setState({
        searchResults: results.map((i: any) => {
          return { text: i.name, value: i.id };
        }),
        qry: qry
      });
    }
  };

  handleSelect = (value: any, option: any) => {
    this.setState({
      searchResults: [{ text: option.props.children, value: value }],
      qry: option.props.children
    });
    this.props.handleMerchantSelect(value);
  };

  rangeSelect = (value: any, dateString: any) => {
    this.props.handleRangeSelect(value);
  };

  disabledDate = (current: any) => {
    // Can not select days before today and today
    // Component has a default 16 month limit
    let monthLimit = this.props.dateSelectionLimit || 16;
    return (
      current < moment().subtract(monthLimit, "months") ||
      current > moment().subtract(1, "days")
    );
  };

  publicationText = () => {
    let { publicationIds = [] } = this.props;
    let publicationText = null as any;
    if (publicationIds)
      if (publicationIds.length)
        publicationText = `(${publicationIds.length} Selected)`;
      else publicationText = "";

    return publicationText;
  };

  handleSubmitPress = () => {
    const { publicationIds, startDate, endDate, merchantId } = this.props;
    if (this.props.handleSubmit)
      this.props.handleSubmit(publicationIds, startDate, endDate, merchantId);

    this.props.toggleMenu();
  };

  handleCancelPress = () => {
    this.setState({ useDefaultMerchant: true });
    this.props.toggleMenu(true);
  };

  rangePickerValues = () => {
    return {
      Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
      "This Week": [moment().startOf("week"), moment().subtract(1, "days")],
      "Last Week": [
        moment().startOf("week").subtract(7, "d"),
        moment().startOf("week")
      ],
      "This Month": [moment().startOf("month"), moment().subtract(1, "days")],
      "Last Month": [
        moment().subtract(1, "months").startOf("month"),
        moment().subtract(1, "months").endOf("month")
      ],
      "Last 3 Months": [
        moment().subtract(3, "months").startOf("month"),
        moment().subtract(1, "months").endOf("month")
      ]
    };
  };

  renderCheckbox = () => {
    let __this = this;
    let { publications = [], publicationIds = [] } = this.props;
    //let {publication, publicationIds} = this.props
    publications = _.filter(publications, function (o) {
      return (
        o.flyer_run_name
          .toLowerCase()
          .indexOf(__this.state.publicationFilter) != -1
      );
    });
    return (
      <Checkbox
        style={{ marginLeft: 20 }}
        checked={publications.length == publicationIds.length}
        onChange={(e: any) =>
          this.props.selectAllPublications(
            e.target.checked,
            this.state.publicationFilter
          )
        }
      >
        Select All
      </Checkbox>
    );
  };

  render() {
    let __this = this;
    const publicationFilter =
      __this.state.publicationFilter.toLocaleLowerCase();
    let {
      startDate,
      endDate,
      publications = [],
      publicationIds = [],
      merchantId,
      merchants = [],
      publications_loading = false,
      togglePublication
    } = this.props;
    let selectedMerchant = merchants.find((i: any) => i.id == merchantId);
    let publicationTypes = _.groupBy(publications, function (o) {
      return o.flyer_type_name;
    });
    publications = _.filter(publications, function (o) {
      return o.flyer_run_name.toLowerCase().indexOf(publicationFilter) != -1;
    });
    let publicationsTypeFilter = _.filter(publications, function (o) {
      return o.flyer_type_name.toLowerCase().indexOf(publicationFilter) != -1;
    });

    // We use these props to reset the Merchant input field when the user clicks cancel.
    const valueProps = this.state.useDefaultMerchant
      ? { value: selectedMerchant ? selectedMerchant.name : "" }
      : {};
    publications = _.sortBy(publications, ["available_to"]);
    publications.reverse();

    return (
      <div className="query-menu-wrapper">
        <div className="menu-toggle" onClick={this.handleCancelPress} />
        <div className="ant-dropdown-menu">
          <div className="dropdown-wrapper">
            <div id="date-range-picker">
              <h3>Date Range</h3>
              <RangePicker
                value={
                  startDate
                    ? [moment(startDate), moment(endDate)]
                    : [null, null]
                }
                disabledDate={this.disabledDate}
                ranges={this.rangePickerValues()}
                format="ll"
                allowClear={false}
                onChange={this.rangeSelect}
              />
            </div>
            {merchants.length != 1 ? (
              <div id="retailer-picker">
                <h3> Retailer </h3>
                <AutoComplete
                  children={<input id="merchant-search-input" maxLength={20} />}
                  allowClear={false}
                  dataSource={this.state.searchResults}
                  style={{ width: "100%" }}
                  defaultValue={selectedMerchant ? selectedMerchant.name : ""}
                  onChange={this.handleChange}
                  onSelect={this.handleSelect}
                  placeholder="Select a Retailer"
                  {...valueProps}
                />
              </div>
            ) : null}
          </div>
          <br />
          {publications_loading ? (
            <QuerySelectorLoadSpin />
          ) : (
            <div className="publication-container" style={{ height: 375 }}>
              <div style={{ marginBottom: 5, fontSize: 16, color: "#4A4A4A" }}>
                Publications &nbsp;
                <span
                  style={{ fontWeight: "bold" }}
                  className="publicationSelected"
                >
                  {this.publicationText()}
                </span>
                <Search
                  placeholder="Filter"
                  onChange={(value: any) => {
                    this.setState({ publicationFilter: value.target.value });
                  }}
                  style={{ width: 200, marginLeft: 50 }}
                />
                <span
                  style={{
                    fontWeight: "bold",
                    float: "right",
                    marginRight: 20
                  }}
                >
                  {publications.length ? this.renderCheckbox() : ""}
                </span>
              </div>
              <div className="publicationTabs">
                <Tabs
                  tabBarStyle={{ marginBottom: 0 }}
                  defaultActiveKey="1"
                  onChange={(e: any) => {
                    this.props.selectAllPublications(false, "");
                  }}
                >
                  <TabPane tab="Publications" key="1">
                    <div style={{ height: 260, overflow: "auto" }}>
                      {publications.map((i: any) => {
                        return (
                          <FlyerThumbnail
                            key={i.flyer_run_id}
                            publication={i}
                            publicationIds={publicationIds}
                            publicationGroup={null}
                            publications={null}
                            togglePublication={togglePublication}
                          />
                        );
                      })}
                    </div>
                  </TabPane>
                  <TabPane tab="Publication Type" key="2">
                    <div style={{ height: 260, overflow: "auto" }}>
                      {Object.keys(publicationTypes).map((i: any) => {
                        if (i.toLowerCase().indexOf(publicationFilter) != -1) {
                          return (
                            <FlyerThumbnail
                              key={i}
                              publication={publicationTypes[i][0]}
                              publicationIds={publicationIds}
                              publicationGroup={i}
                              publications={publicationTypes[i]}
                              togglePublication={togglePublication}
                            />
                          );
                        }
                      })}
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          )}
          <div style={{ padding: 10 }}>
            <div style={{ textAlign: "right" }}>
              <Button
                className="cancel-button"
                style={{ marginRight: 5 }}
                onClick={this.handleCancelPress}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                disabled={publicationIds.length == 0}
                onClick={this.handleSubmitPress}
                data-automation-id="query-selector-confirm"
              >
                Show Data
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/common/components/QuerySelector/QueryMenu/index.tsx